import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
type Testimonial = {
  name: string;
  age: number;
  quote: string;
  photo: string;
  initials: string;
};
const testimonials: Testimonial[] = [{
  name: 'Laura',
  age: 48,
  quote: 'Volví a sentir más energía durante el día.',
  photo: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop&crop=faces&auto=format&q=80',
  initials: 'L'
}, {
  name: 'Andrea',
  age: 52,
  quote: 'Por primera vez sentí que entendía mi cuerpo.',
  photo: 'https://images.unsplash.com/photo-1551836022-deb4988cc6c0?w=400&h=400&fit=crop&crop=faces&auto=format&q=80',
  initials: 'A'
}, {
  name: 'Claudia',
  age: 46,
  quote: 'Dejé de sentirme en guerra conmigo misma.',
  photo: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop&crop=faces&auto=format&q=80',
  initials: 'C'
}, {
  name: 'Patricia',
  age: 50,
  quote: 'Aprendí a escuchar lo que mi cuerpo realmente necesitaba.',
  photo: 'https://images.unsplash.com/photo-1592621385612-4d7129426394?w=400&h=400&fit=crop&crop=faces&auto=format&q=80',
  initials: 'P'
}, {
  name: 'Isabel',
  age: 49,
  quote: 'Encontré una forma más amable de cuidarme.',
  photo: 'https://images.unsplash.com/photo-1605405748313-a416a1b84491?w=400&h=400&fit=crop&crop=faces&auto=format&q=80',
  initials: 'I'
}, {
  name: 'Carmen',
  age: 54,
  quote: 'Volví a conectar con esa versión de mí que extrañaba.',
  photo: 'https://images.unsplash.com/photo-1567532939604-b6b5b0db2604?w=400&h=400&fit=crop&crop=faces&auto=format&q=80',
  initials: 'C'
}];
function TestimonialAvatar({
  photo,
  initials,
  name
}: {
  photo: string;
  initials: string;
  name: string;
}) {
  return <div className="relative w-16 h-16 md:w-[72px] md:h-[72px] flex-shrink-0" data-id="element-294">
      <img src={photo} alt={`Foto de ${name}`} className="w-full h-full rounded-full object-cover shadow-md ring-2 ring-warm-white" loading="lazy" onError={e => {
      const target = e.currentTarget as HTMLImageElement;
      target.style.display = 'none';
      const fallback = target.nextElementSibling as HTMLDivElement | null;
      if (fallback) fallback.style.display = 'flex';
    }} data-id="element-295" />
      <div className="absolute inset-0 rounded-full bg-forest text-gold-light font-serif font-bold items-center justify-center shadow-md ring-2 ring-warm-white text-2xl" style={{
      display: 'none'
    }} aria-hidden="true" data-id="element-296">
        {initials}
      </div>
    </div>;
}
export function Testimonials() {
  return <section className="bg-cream py-20 md:py-28" data-id="element-297">
      <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-298">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-299">
          <p className="text-center text-xs md:text-sm font-bold tracking-[0.2em] text-gold uppercase mb-4" data-id="element-300">
            Voces de mujeres reales
          </p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-charcoal mb-4 text-center leading-tight" data-id="element-301">
            Pequeñas historias.{' '}
            <span className="italic text-forest" data-id="element-302">Grandes cambios.</span>
          </h2>
          <p className="text-center text-charcoal/60 text-base md:text-lg mb-16 max-w-2xl mx-auto" data-id="element-303">
            Mujeres que comenzaron a relacionarse de otra forma con su cuerpo y
            su bienestar.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7" data-id="element-304">
            {testimonials.map((t, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.08
          }} className="relative bg-warm-white rounded-2xl p-7 md:p-8 shadow-[0_8px_30px_rgba(0,0,0,0.06)] border border-charcoal/5 flex flex-col items-center text-center" data-id="element-305">
                <SparklesIcon className="w-6 h-6 text-gold mb-5" aria-hidden="true" data-id="element-306" />

                <blockquote className="font-serif text-lg md:text-xl text-charcoal italic leading-snug mb-6 flex-1" data-id="element-307">
                  "{t.quote}"
                </blockquote>

                <div className="flex items-center gap-3 pt-4 border-t border-charcoal/10 w-full justify-center" data-id="element-308">
                  <TestimonialAvatar photo={t.photo} initials={t.initials} name={t.name} data-id="element-309" />
                  <p className="text-charcoal/75 text-sm md:text-base" data-id="element-310">
                    <span className="font-semibold text-charcoal" data-id="element-311">
                      {t.name}
                    </span>
                    , {t.age}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}